import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { environment } from "../../environments/environments";
import bgImage from "../../assets/images/brown-background.jpg";
import "../UploadImage/UploadImage.css";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";
import {
  buildUploadImageFormData,
  getSafeUploadErrorMessage,
  submitUploadImageRequest,
} from "./uploadImageHelpers";

const MAX_IMAGE_SIZE = 2 * 1024 * 1024;
const MAX_WIDTH = 800;
const MAX_HEIGHT = 800;

const UploadImage = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  useEffect(() => {
    Swal.fire({
      icon: "warning",
      title: "Notice",
      text: "Kindly note that using fake or inappropriate pictures may result in account cancellation.",
    });
  }, []);

  const resizeImage = (file, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > MAX_WIDTH || height > MAX_HEIGHT) {
          const scaleFactor = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
          width = Math.round(width * scaleFactor);
          height = Math.round(height * scaleFactor);
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob.size > MAX_IMAGE_SIZE) {
              alert("Image size too large even after resizing!");
              return;
            }
            callback(blob);
          },
          "image/jpeg",
          0.9
        );
      };
    };
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (images.length + selectedFiles.length > 5) {
      alert("You can upload up to 5 images only.");
      return;
    }

    selectedFiles.forEach((file) => {
      resizeImage(file, (resizedBlob) => {
        const preview = URL.createObjectURL(resizedBlob);
        setImages((prev) => [...prev, { blob: resizedBlob, preview }]);
      });
    });
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleUpload = async () => {
    if (images.length === 0) {
      // alert("Please select at least one image.");
      Swal.fire({
        icon: "warning",
        title: "No Image Selected",
        text: "Please select at least one image.",
      });
      return;
    }

    setIsLoading(true);
    try {
      const userDatas = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatas);
      const userId = parsedUserData?.id || parsedUserData?._id;
      // Do not set Content-Type manually — browser/Axios must attach the multipart boundary.
      const formData = buildUploadImageFormData({
        userId,
        acceptTerms,
        images,
      });
      console.log("uploadImage-formData", formData);
      const response = await submitUploadImageRequest(
        axios,
        environment.baseURL,
        formData
      );
      console.log("uploadImage-api-response", response);
      if (response.data?.success) {
        navigate("/DocumentUpload");
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data?.message || "Something went wrong!",
        });
      }
    } catch (error) {
      console.error("Upload Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: getSafeUploadErrorMessage(error),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="UploadImagecontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="backgggsec">
          <h2 className="uploadimageheader">Upload Image</h2>

          <div className="image-grid">
            {images.map((img, index) => (
              <div className="uploadimage-box" key={index}>
                <img
                  src={img.preview}
                  alt={`Upload ${index}`}
                  className="fuploaded-image"
                />
                <button
                  className="delete-button"
                  onClick={() => removeImage(index)}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>


          <input
            type="file"
            id="fileInput"
            accept="image/*"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {images.length > 0 && (
            <div className="checkbox-area">
              <input
                type="checkbox"
                id="consent"
                className="imagechackbox"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
              />
              <label htmlFor="consent" className="permissionLabel">
                I give my consent to display my profile image(s) to other user(s).
              </label>
            </div>
          )}
          <div>
            <p className="uploadedPicturesText">
              {" "}
              Uploaded Pictures ({images.length})
            </p>
          </div>
          {images.length < 5 && (
            <button
              className="imageupload-box"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Click to Upload Image
            </button>
          )}
          <button
            className="continue-button"
            onClick={handleUpload}
            // disabled={isLoading || images.length === 0 || !acceptTerms}
            disabled={isLoading || images.length === 0}
          >
            {isLoading ? "Uploading..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadImage;
